// extracted by mini-css-extract-plugin
export var list = "tags-module--list--jYD4r";
export var item = "tags-module--item--YgCuB";